module.exports = __webpack_public_path__ + "static/img/feature-icon1@3x.00717595.png";